// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"styles_checkboxLabel__pH5qd","space":"styles_space__2ZGhJ"};